// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"088380b1","453":"b66d3113"}[chunkId] + ".chunk.js";
};